var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClasses,style:(_vm.customCSS),attrs:{"id":"ButtonWithLoadingContainer"},on:{"click":_vm.clicked}},[(_vm.loading)?_c('span',{staticClass:"material-icons icon spin"},[_vm._v("autorenew")]):_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }